import builder from '../builder';
import CommonFileTextInfo from '../../streamline-icons/bold/common-file-text-info.svg';

export default builder('CommonFileTextInfoBold', CommonFileTextInfo);
